import React from 'react'
import {Route} from 'react-router'
import asyncComponent from '../../core/components/async-component/AsyncComponent'

const AsyncSpark = asyncComponent({
  loader: () => import('./components/Spark'),
  modules: ['./components/Spark'],
  webpack: () => [require.resolveWeak('./components/Spark')]
})

const sparkRoute = [
  <Route exact key='spark' path='/spark' component={AsyncSpark} />,
  <Route exact key='spark' path='/spark/apply' component={AsyncSpark} />,
]
export default sparkRoute



// WEBPACK FOOTER //
// ./src/domains/spark/index.js